module.exports = __webpack_public_path__ + "images/index/img02.c24cb59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/children/new/img02.jpg
// module id = 4oPx
// module chunks = 21